export const useBirraData = (data) => {
  const categories = computed(() => {
    const birraCategories = data.value.categories || []
    return birraCategories.filter(
      (category) => category.__typename === 'categoriaLievitoBirra_Category',
    )
  })

  return { categories }
}

export const useBirraItem = (categories) => {
  const findBirraItemBySlug = (slug) => {
    let category = categories.find((category) => category.slug === slug)
    if (category) return category

    return null
  }

  return { findBirraItemBySlug }
}

export const generateBirraDefaultFacetsFilters = (currentCategory) => {
  const filters = [
    [`Filtro_Categoria_Lievito_Birra:${currentCategory.value.algoliaKey}`],
  ]
  return filters
}
